import {Component, HostListener, OnInit} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatDialog} from "@angular/material/dialog";
import {CreateLabSubmissionComponent} from "../../dialogs/lab-manager/create-lab-submission/create-lab-submission.component";
import {LabManagerService} from "../lab-manager.service";
import {Router} from "@angular/router";
import {HelperService} from "../../helper.service";
import {OrderManagerService} from "../../order-to-cash/services-otc/order-manager.service";
import {NavBarComponent} from "../../nav-bar/nav-bar.component";
import {LabManagerSharedDataService} from "../lab-manager-shared-data.service";
import {BasicLabManagerItemModel} from "../../models/lab-manager/basic-lab-manager-item";
import {LabAgentModel} from "../../models/lab-manager/lab-agent";
import {LabSubmissionModel} from "../../models/lab-manager/lab-submission";
import dayjs from "dayjs";
import {PageEvent} from "@angular/material/paginator";
import {RepresentativeModel} from "../../models/lab-manager/representative";
import {FormControl} from "@angular/forms";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {LAB_MANAGER_DATE_FORMAT} from "../lab-samples/lab-samples.component";
import { FilterDialogComponent } from 'src/app/recommendation-manager/dialogs/filter-dialog/filter-dialog.component';
import { CustomerModel } from 'src/app/order-to-cash/models-otc/customer-model';
import { User } from 'src/app/models/user';

@Component({
    selector: 'app-lab-submissions',
    templateUrl: './lab-submissions.component.html',
    styleUrls: ['./lab-submissions.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: LAB_MANAGER_DATE_FORMAT }
    ],
    standalone: false
})
export class LabSubmissionsComponent implements OnInit {

    showPageSizeMenu: boolean = false;
    currentPage: number = 0;
    dataSource: MatTableDataSource<LabSubmissionModel> = new MatTableDataSource<LabSubmissionModel>();
    displayedColumns: string[] = [
        'labSubmission',
        'dateCreated',
        'client',
        'createdBy',
        'noOfSamples',
        'type',
        'status',
        'actions'
    ];
    isRepresentative: boolean = false;
    isAgronomist: boolean = false;
    noItemsFound: boolean = false;
    isFilterBtnVisible: boolean = false;
    pageSize: number = 25;
    labAgentList: User[] = [];
    selectedLabAgentId: number;
    userRoles: any[] = JSON.parse(sessionStorage.getItem('roles'));
    representatives: RepresentativeModel[] = [];
    selectedRepresentative: RepresentativeModel;
    startDate: string;
    endDate: string;
    searchText: string = '';
    submissionTypes: BasicLabManagerItemModel[] = [];
    tableHeight: string = (window.innerHeight - 280) + 'px';
    user: User = JSON.parse(sessionStorage.getItem('user'));
    timerInterval: any;
    totalElements: number = 0;
    showToolTip: boolean = false;
    userId: number = this.helper.getUserId();
    customerList: CustomerModel[] = [];
    selectedClientId: number = 0;
    statusList: BasicLabManagerItemModel[] = [];
    selectedStatusIds: number[] = [];
    selectedSubmissionType: number = null;

    constructor(
        private dialog: MatDialog,
        private labManagerService: LabManagerService,
        private router: Router,
        private helper: HelperService,
        private orderManagerService: OrderManagerService,
        private nav: NavBarComponent,
        private labShareService: LabManagerSharedDataService
    ) {}

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.tableHeight = (window.innerHeight - 280) + 'px';
    }

    ngOnInit(): void {
        sessionStorage.removeItem('representative');
        this.isRepresentative = this.userRoles?.findIndex(r => r.name === 'LabManagerRepresentative') !== -1;
        this.isAgronomist = this.userRoles?.findIndex(r => r.name === "Agronomist") !== -1;
        this.nav.toggleLoading(true);
        if(this.isRepresentative) {
            this.getLabRepresentatives();
        } else {
            this.getSubmissionTypes();
            this.getLabSubmissions();
        }

        if(this.isAgronomist) {
            this.getLabAgentList();
        }

        this.getCustomerList();
        this.getLabMangerStatusList();
    }

    getCustomerList() {
        this.labManagerService.getCustomers().subscribe({
            next: res => {
                this.customerList = res;
            }
        })
    }

    getLabMangerStatusList() {
        this.labManagerService.getLabManagerStatusList().subscribe({
            next: res => {
                this.statusList = res;
            }
        })
    }

    getLabAgentList() {
        this.labManagerService.getLabAgentListForAgronomist().subscribe({
            next: (res) => {
                this.labAgentList = res;
            }
        })
    }

    resetFilter(){
        this.searchText = '';
        this.startDate = null;
        this.endDate = null;
        this.selectedClientId = null;
        this.selectedStatusIds = [];
        this.selectedLabAgentId = 0;
        this.selectedSubmissionType = 0;
        this.getLabSubmissions();
    }

    addNewLabSubmission() {
        const dialogRef = this.dialog.open(CreateLabSubmissionComponent,{
            data: {
                submissionTypes: this.submissionTypes
            },
            width: '420px'
        });

        dialogRef.afterClosed().subscribe((result: BasicLabManagerItemModel) => {
            if(result) {
                this.nav.toggleLoading(true);

                this.labManagerService.addLabSubmission(result.id, this.helper.getUserId(), this.isRepresentative).subscribe({
                    next: (response: any) => {
                        this.nav.toggleLoading(false);
                        this.routeToLabSubmissionDetails(response.id)
                    },
                    error: () => {
                        this.nav.toggleLoading(false);
                    }
                })
            }
        })
    }

    openFilterDialog() {
        const dialogRef = this.dialog.open(FilterDialogComponent,
            {
                data: {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    selectedClientId: this.selectedClientId,
                    customerList: this.customerList,
                    selectedStatusIds: this.selectedStatusIds,
                    statusList: this.statusList,
                    labAgentList: this.labAgentList,
                    selectedLabAgentId: this.selectedLabAgentId,
                    submissionTypes: this.submissionTypes,
                    selectedSubmissionType: this.selectedSubmissionType
                },
                width: '400px',
                maxHeight: '90vh',
                panelClass: 'no-scroll-dialog'
            }
        );

        dialogRef.afterClosed().subscribe({
            next: res => {
                if(res) {
                    console.log(res)
                    this.selectedClientId = res?.selectedClientId;
                    this.startDate = res?.startDate != null ? dayjs(res.startDate).format('YYYY-MM-DD') : null;
                    this.endDate = res?.endDate != null ? dayjs(res.endDate).format('YYYY-MM-DD') : null;
                    this.selectedStatusIds = res?.selectedStatusIds;
                    this.selectedLabAgentId = res?.selectedLabAgentId;
                    this.selectedSubmissionType = res?.selectedSubmissionType;
                    this.hideShowFilterReset();
                    this.getLabSubmissions();
                }
            }
        })
    }

    getLabSubmissions() {
        if(this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        this.nav.toggleLoading(true);
        this.labManagerService.getSubmissionList(this.currentPage, this.pageSize, this.startDate, this.endDate, this.searchText, this.isRepresentative, this.selectedStatusIds, this.selectedClientId, this.selectedLabAgentId, this.selectedSubmissionType).subscribe({
            next: (res) => {
                this.dataSource = new MatTableDataSource<LabSubmissionModel>(res.content);
                this.totalElements = res.totalElements;
                // this.pageSize = res.
                this.hideShowFilterReset();
            },
            error: () => {
                this.nav.toggleLoading(false);
            },
            complete: () => {
                this.nav.toggleLoading(false);
            }
        });
    }

    hideShowFilterReset(){
        this.isFilterBtnVisible = (this.selectedSubmissionType != null && this.selectedSubmissionType > 0) || this.searchText?.length > 0 || (this.selectedClientId !== null && this.selectedClientId > 0) || this.startDate != null || this.endDate != null || this.selectedStatusIds?.length > 0 || this.selectedLabAgentId > 0;
    }

    getSubmissionTypes() {
        this.labManagerService.getSubmissionTypes().subscribe((res: BasicLabManagerItemModel[]) => {
            this.submissionTypes = res;
        });
    }

    getLabRepresentatives() {
        this.labManagerService.getLabRepresentatives(this.user.id).subscribe({
            next: (res: RepresentativeModel[]) => {
                this.representatives = res;

                if(sessionStorage.getItem('currentAgent')) {
                    let currentAgent = JSON.parse(sessionStorage.getItem('currentAgent'));

                    this.selectedRepresentative = this.representatives.find(a => a?.id === currentAgent?.id);
                } else {
                    this.selectedRepresentative = this.representatives[0];
                    sessionStorage.setItem('representative', JSON.stringify(this.selectedRepresentative));
                }

                this.getSubmissionTypes();
                this.getLabSubmissions();

            },
            error: () => {
                this.nav.toggleLoading(false);
            }
        });
    }

    searchLabSubmissions() {
        if(this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        this.timerInterval = setInterval(() => {
            this.getLabSubmissions();
        }, 800);
    }

    onPaginateChange(event: PageEvent) {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.getLabSubmissions();
    }

    setSelectedLabAgent(agent: RepresentativeModel) {
        sessionStorage.setItem('representative', JSON.stringify(agent));
        this.getLabSubmissions();
    }

    routeToLabSubmissionDetails(submissionId: number) {
        this.router.navigateByUrl(`lab-manager/submission/${submissionId}`);
        this.labShareService.labSubmissionIdSubject.next(submissionId)
    }

    goToPage(page: number) {
        this.currentPage = page;
        this.getLabSubmissions();
    }

    onPageSizeChange(size: number) {
        this.pageSize = size;
        this.currentPage = 0;
        this.showPageSizeMenu = false;
        this.getLabSubmissions();
    }

    get lastPage(): number {
        return Math.max(0, Math.ceil(this.totalElements / this.pageSize) - 1);
    }

    min(a: number, b: number): number {
        return Math.min(a, b);
    }
}
